export default __webpack_public_path__ + "static/media/b&rlogo.fd5bd1bb.png";